'use client';
import clsx from 'clsx';
import React from 'react';
import { type ItemValue, type QuestionRadiogroupModel } from 'survey-core';

import RadioItem from '../radioItem';
import RadioItemHoriz from '../radioItemHoriz';

const RadioGroup = ({
  question,
}: {
  question: QuestionRadiogroupModel & { jsonObj: any };
}) => {
  if (question?.jsonObj?.choicesOrder === 'random') {
    question.choices.sort(() => {
      return Math.random() < 0.5 ? -1 : 1;
    });
  }

  return (
    <>
      <div
        role="presentation"
        className={clsx(
          'cur-text-primary cur-input-radiogroup',
          question.optionOrientation === 'horizontal'
            ? 'cur-grid cur-grid-cols-3 cur-gap-y-4'
            : 'cur-space-y-4',
        )}
      >
        {question.optionOrientation === 'horizontal' &&
          question.choices
            .filter((choice: ItemValue) => choice.visible)
            .map((choice: ItemValue) => (
              <RadioItemHoriz
                key={choice.value}
                question={question}
                item={choice}
                isChecked={question.isItemSelected(choice)}
              />
            ))}
        {question.optionOrientation !== 'horizontal' &&
          question.choices
            .filter((choice: ItemValue) => choice.visible)
            .map((choice: ItemValue) => (
              <RadioItem
                key={choice.value}
                question={question}
                item={choice}
                isChecked={question.isItemSelected(choice)}
              />
            ))}
      </div>
      {question.content && (
        <div className="cur-mt-2">
          <div
            className="cur-prose cur-prose-sm"
            dangerouslySetInnerHTML={{ __html: question.content }}
          />
        </div>
      )}
    </>
  );
};

export default RadioGroup;
